<ng-container>
    <nb-card>
        <nb-card-header>Customer Payment Methods</nb-card-header>
        <nb-card-body>
            <pty-customer-eft-account [partyId]="partyId"></pty-customer-eft-account>
            <pty-customer-credit-card [partyId]="partyId"></pty-customer-credit-card>
            <pty-customer-billing-account [partyId]="partyId"></pty-customer-billing-account>
            <pty-customer-cheque-account [partyId]="partyId"></pty-customer-cheque-account>
        </nb-card-body>
    </nb-card>    
</ng-container>
